<template>
  <nav :class="navClass">
    <router-link
      v-for="link in navigationLinks"
      :key="link.name"
      :to="link.to"
      :class="[
        'px-3 py-2 text-sm font-medium transition-colors',
        'hover:text-gray-900',
        $route.name === link.name 
          ? 'text-primary-600 border-b-2 border-primary-600' 
          : 'text-gray-600'
      ]"
    >
      {{ link.label }}
    </router-link>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface NavigationLink {
  name: string
  to: string
  label: string
  requiresAuth?: boolean
}

interface Props {
  mobile?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  mobile: false
})

const navClass = computed(() => {
  if (props.mobile) {
    return 'flex flex-col space-y-1'
  }
  return 'hidden md:flex space-x-8'
})

const navigationLinks: NavigationLink[] = [
  {
    name: 'models',
    to: '/models',
    label: 'Models'
  },
  {
    name: 'chat',
    to: '/chat',
    label: 'Chat',
    requiresAuth: true
  },
  {
    name: 'rankings',
    to: '/rankings',
    label: 'Rankings'
  },
  {
    name: 'docs',
    to: '/docs',
    label: 'Docs'
  }
]
</script> 